import { TopicComparisonMeasureType } from 'enums'
import { ColDefs } from 'components/visualization/Table'
import { RowData } from './types'

const MIN_SPARKLINE_WIDTH = 100
const SPARKLINE_INTERVAL_WIDTH = 15

/**
 * calc max width(px) of the sparkline inside trend column
 * @param trendData array of trends
 */
const calcMaxSparklineWidth = (trendData: number[][]) => {
  const maxDataPointCounts = Math.max(...trendData.map((d) => d?.length))
  const maxWidth = (maxDataPointCounts - 1) * SPARKLINE_INTERVAL_WIDTH

  if (maxWidth < MIN_SPARKLINE_WIDTH) {
    return `${MIN_SPARKLINE_WIDTH}px`
  }
  return `${maxWidth}px`
}

/**
 * dynamically calc some constraints based on data to be dispalyed in table
 * @param rowData data displayed in table
 */
const calcConstraints = (rowData: RowData[], colDefs: ColDefs<any, any, any>) => {
  const trendData = rowData.map(
    (row) =>
      row[TopicComparisonMeasureType.MENTIONS_TREND] || row[TopicComparisonMeasureType.POSTS_TREND]
  )
  return {
    isDisplayIcon: rowData.some((d) => !!d.imageUrl),
    maxSparklineWidth: calcMaxSparklineWidth(trendData),
    columnWidth: `${(1 / colDefs.length) * 100}%`
  }
}

export default calcConstraints
